import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loading from '../../components/Loading';
import useUser from '../../hooks/useUser';
import AuthFirstSalesPage from '../SalesPages/AuthFirstSalesPage';
import { normalizeCheckoutAuthReturnTo } from '../../utils/checkoutAuthNavigation';

const CheckoutAuthPage = (): React.ReactElement => {
  const location = useLocation();
  const { authLoading, isAuthenticated, isLoading } = useUser();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const returnTo = useMemo(() => normalizeCheckoutAuthReturnTo(params.get('returnTo')), [params]);
  const isAuthLoading = authLoading ?? isLoading;
  const analyticsContext = useMemo(
    () => ({
      auth_surface: 'checkout_product_overview',
      checkout_auth_return_to: returnTo,
      source: 'checkout_auth_first',
    }),
    [returnTo],
  );

  if (isAuthLoading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <Navigate replace to={returnTo} />;
  }

  return (
    <AuthFirstSalesPage
      analyticsContext={analyticsContext}
      authHeadingIdOverride="checkout-auth-visible-heading"
      entryMode="checkout"
      presentation="overlay"
      returnTo={returnTo}
    />
  );
};

export default CheckoutAuthPage;
